<!-- 党建工作动态 -->
<template>
<div :class="mobileClass('cm_party_work_container')">
  <Carousel :data="data" />
  <div class="cm_party_work_box" v-loading="loading" style="min-height:280px">
    <div class="cm_party_work_title">
      <img :src="data.imgPath">
      <div class="cm_party_work_title_content" @click="toDetail(dataList[0].NEWS_ID,data)">
        <h3 v-if="dataList.length!=0">{{dataList[0].TITLE}}</h3>
        <!--<span v-if="dataList.length!=0 ">{{dataList[0].SOURCE}}</span>-->
      </div>
    </div>
    <div class="cm_party_work_content_box" >
      <div class="cm_party_work_content_site">
        <h3>{{data.title}}</h3>
        <router-link :to="{path:'/list',query:{urlData:JSON.stringify(data)}}">MORE+</router-link>
      </div>
      <ul class="cm_party_work_content_list">
        <li v-for="(item,index) in dataList" :key="item.NEWS_ID" v-show="index>0" @click="toDetail(item.NEWS_ID,data)">
          <span>{{item.PUBLISH_DATE}}</span>
          <h3>{{item.TITLE}}</h3>
        </li>
      </ul>
    </div>
  </div>
  <div>
    
  </div>
  <div>

  </div>
</div>
</template>

<script>
import Carousel from '@/components/common/Carousel';

export default {
components: {Carousel},
props:['data'],
data() {
//这里存放数据
return {
  url:this.data.url,
  dataList:[],
  windowWidth:document.documentElement.clientWidth,
  loading:true
};
},
//监听属性 类似于data概念
computed: {
  mobileClass(){
       return (val)=>{
         if(this.windowWidth > 500) {
          return val
          } else {
            return "mobile_"+val
          }
       }
    },
},
//监控data中的数据变化
watch: {
  '$store.state.screenWidth': function (val) { //监听屏幕宽度变化
    this.windowWidth = val;
  }
},
//方法集合
methods: {
  httpPost() {
    this.loading = true
      this.$http({
        url: this.$http.adornUrl(this.$store.state.comUrl),
        method: 'post',
        data: this.data.data 
      }).then(({ data }) => {
        if(data.data!=''&&data.data!=undefined&&data.data!=null){
          this.dataList = data.data.pdList
          this.loading = false
        }
          
      });
    },
    toDetail(ID,data){
      this.$router.push({path:'/detail/'+ID,query: {parentData:JSON.stringify(data)}})
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  this.httpPost()
},

}
</script>
<style scoped>
.cm_party_work_container{
  width: 1200px;
  padding: 20px;
  background: #FFFFFF;
  border: 1px solid #E1E4E7;
  display: flex;
  justify-content: space-between;
}
.cm_party_work_box{
  width: 800px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 20px;
  align-content: flex-start;
}
.cm_party_work_title{
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px dashed #CA0E0E;
  height: 130px;
  align-items: center;
  justify-content: space-between;
}
.cm_party_work_title>img{
  width:200px;
  height:84px;
}
.cm_party_work_title_content{
  width: 60%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  cursor: pointer;
}
.cm_party_work_title_content:hover>h3{
  color:#CA0E0E;
}
.cm_party_work_title_content>h3{
  font-size: 24px;
  font-weight: 600;
  color: #565656;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin-bottom: 10px;
}
.cm_party_work_title_content>span{
  font-size: 16px;
  font-weight: 400;
  color: #BBBBBB;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cm_party_work_content_box{
  width:100%;
  padding: 20px 0;
}
.cm_party_work_content_site{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.cm_party_work_content_site>h3{
  font-size: 21px;
  font-weight: bold;
  color: #CA0E0E;
}
.cm_party_work_content_site>a{
  font-size: 14px;
  font-weight: 500;
  color: #BFBFBF;
}
/* .cm_party_work_content_list{

} */
.cm_party_work_content_list>li{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  cursor: pointer;
}
.cm_party_work_content_list>li:hover>h3{
  color: #CA0E0E;
}
.cm_party_work_content_list>li>span{
  width:13%;
  background: #CA0E0E;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cm_party_work_content_list>li>h3{
  width:80%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
  font-weight: 400;
  color: #000000;
}

.mobile_cm_party_work_container{
  width: 100%;
  padding: 20px;
  background: #FFFFFF;
  border: 1px solid #E1E4E7;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.mobile_cm_party_work_container>.cm_party_work_box{
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 20px;
  align-content: flex-start;
}
.mobile_cm_party_work_container>.cm_party_work_box>.cm_party_work_title{
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px dashed #CA0E0E;
  height: auto;
  align-items: center;
  justify-content: space-between;
}
.mobile_cm_party_work_container>.mobile_cm_party_work_container{
  width: 100%;
}
</style>